module.exports = __webpack_public_path__ + "static/media/ic-calendar.4ca6b2ad.svg";